// eligibility/eligibilityLogger.js
// Non-fatal audit logging for eligibility decisions and outcomes.
// Failures are caught and logged — never crash claim or completion flow.
// Suppression enforcement is NOT handled here — it belongs in the completion handler.

import { supabase } from "../services/supabaseService";

/** Log an eligibility decision (at claim time). Supports optional claim_context. */
export async function logEligibilityDecision({ driver_id, job_id, decision_type, confirmed, claim_context = null, metadata = {} }) {
  try {
    await supabase.from("eligibility_decisions").insert({
      driver_id,
      job_id,
      decision_type,
      confirmed,
      claim_context,
      metadata,
      decided_at: new Date().toISOString(),
    });
  } catch (e) {
    console.error("[eligibilityLogger] decision log failed:", e.message);
  }
}

/** Fetch the most recent claim context for a driver + job. */
export async function getClaimContext(driverId, jobId) {
  try {
    const { data, error } = await supabase
      .from("eligibility_decisions")
      .select("claim_context")
      .eq("driver_id", driverId)
      .eq("job_id", jobId)
      .eq("confirmed", true)
      .order("decided_at", { ascending: false })
      .limit(1)
      .maybeSingle();
    if (error) throw error;
    return data?.claim_context || null;
  } catch (e) {
    console.error("[eligibilityLogger] claim context fetch failed:", e.message);
    return null;
  }
}

/** Log an eligibility outcome (at completion time). Audit-only — no enforcement. */
export async function logEligibilityOutcome({ driver_id, job_id, trailer_required, trailer_used, success, metadata = {} }) {
  try {
    await supabase.from("eligibility_outcomes").insert({
      driver_id,
      job_id,
      trailer_required,
      trailer_used,
      success,
      metadata,
      completed_at: new Date().toISOString(),
    });
  } catch (e) {
    console.error("[eligibilityLogger] outcome log failed:", e.message);
  }
}
